<div class="sas-select-wrapper {{sasClass}}">
  <label class="form-label"
         translate="{{label}}"
         [class.visually-hidden]="hideLabel"
         [for]="instanceId"
         [id]="labelId"
         [textContent]="label"
         [title]="sasHelptext | translate">
  </label>
  @if(validation.required){
  <span> *</span>
  }
  @if(sasHelptext){
  <div class="sas-inline-block" [title]="sasHelptext | translate">
    <i aria-hidden="true" class="bi bi-info-circle-fill sas-info-icon"></i>
  </div>
  }
  <select #fieldModel="ngModel"
          class="form-select sas-select {{sasClass}}"
          sasTruncateSelectOptions
          [attr.aria-describedby]="hasVisibleError ? instanceId + 'Desc' : null"
          [attr.aria-invalid]="hasVisibleError"
          [attr.aria-labelledby]="labelId"
          [attr.aria-required]="ariaRequired"
          [class.is-invalid]="hasVisibleError"
          [disabled]="sasDisabled"
          [id]="instanceId"
          [name]="name"
          [required]="validation?.required ?? false"
          [sasEmptyValue]="null"
          [sasMarkOnSubmit]="formId"
          [title]="sasHelptext | translate"
          [(ngModel)]="value"
          (ngModelChange)="onSelectChange($event)">
    <option selected [ngValue]="null">{{ 'SAS_SELECT.DEFAULT_TEXT' | translate }}</option>
    @for(item of items; track $index){
      <option [ngValue]="item.id" [title]="item.name | translate">{{item.name | translate}}</option>
    }
  </select>
  <div aria-atomic="true" class="invalid-feedback" role="alert" [id]="instanceId + 'Desc'">
    <small>{{ templateDrivenFieldService.getFieldErrorMessage(fieldModel, validation) }}</small>
  </div>
</div>
